import ReactPaginate from 'react-paginate'
import styled from 'styled-components'

import { Button, getArrowStyle } from './Buttons'

export const StyledPaginate = styled(ReactPaginate)<{ isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  list-style: none;
  margin: 0;
  padding: 0;
  min-width: 21rem;
  justify-content: space-between;
  height: 100%;

  & li {
    ${Button}

    &:first-child {
      ${getArrowStyle('left')}
    }

    &:last-child {
      ${getArrowStyle('right')}
    }
  }
`
